export default (set, get, segmentHeights) => set(
  () => ({
    compatibilityHeights: segmentHeights
  }),
  false,
  { type: 'updateCompatibilityHeights', payload: segmentHeights.length }
);
